import React, { useContext } from 'react'
import cn from 'classnames'
import PropTypes from 'prop-types'
import { DropdownItem, Icon } from '@mc/design-system'
import { SearchContext } from '../../SearchContext'
import classes from './CategoriesList.module.scss'

const CategoriesList = ({ items }) => {
  const { onCategoryClick } = useContext(SearchContext)

  const handleCategoryClick = (category) => {
    onCategoryClick(category)
  }

  return (
    <div>
      {items.map((subject) => (
        <DropdownItem key={subject.value}>
          <a
            className='align-items-center mc-py-3 mc-pr-3 mc-pl-4 mc-text-left d-flex'
            onClick={() => handleCategoryClick(subject.value)}
          >
            <span>{subject.label}</span>
            <Icon
              kind='chevron-right'
              className={cn(classes.icon, 'mc-icon--2')}
            />
          </a>
        </DropdownItem>
      ))}
    </div>
  )
}

CategoriesList.propTypes = {
  items: PropTypes.array,
}

export default CategoriesList
